import React from "react";
import { useLocalization } from "@fluent/react";

export default function Loading() {
  const { l10n } = useLocalization();
  return (
    <div className="ui one column grid">
      <div
        className="ui wireframe placeholder"
        style={{ height: "10em" }}
      ></div>
      <div className="ui inverted dimmer active">
        <div className="ui text loader active">{l10n.getString("message-loading", null, "Loading")}</div>
      </div>
    </div>
  );
}
